
export function resolveEffectiveElementFormId(options: {
  contextFormId?: string | number | null
  pageRegistryFormId?: string | number | null
  pageDataSlot?: string | number | null
}): string {
  const registryId = String(options.pageRegistryFormId ?? '').trim()
  const slotId = String(options.pageDataSlot ?? '').trim()
  const ctxRaw = options.contextFormId
  const ctxId =
    ctxRaw != null && String(ctxRaw).trim() !== '' && String(ctxRaw) !== '-1'
      ? String(ctxRaw).trim()
      : ''

  if (registryId && slotId && registryId !== slotId) {
    return registryId
  }
  if (ctxId) return ctxId
  return registryId || ctxId
}
